export const environment = {
  production: false,
  baseUrl: 'https://stage.ndv.ru',
  apiBaseUrl: 'https://stage.ndv.ru/backend-api',
  jsApiBaseUrl: 'https://stage.ndv.ru:4443/js-api'
};
